import React, {useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {
    getAuthHeader,
    getDomain,
    getLink, getLocalStorageItem, getPathBack, isValidUrl,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow, setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {PathLineClass} from "../elements/PathLineClass"

export const CreateLinkPage = () => {
    setLocalStorageItem('page', 'CreateLinkPage')
    const $ = require("jquery")

    let lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const urlParams = new URLSearchParams(window.location.search)
    const folderId = urlParams.get('folderId')
    const [clipboard, setClipboard] = useState(undefined)
    const [textUrl, setTextUrl] = useState('')
    const [textName, setTextName] = useState('')
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})

    const changeHandlerUrl = (e) => {
        setTextUrl(e.target.value)
    }

    const changeHandlerName = (e) => {
        setTextName(e.target.value)
    }

    useEffect(() => {
        window.M.updateTextFields()
    }, [])

    useEffect(() => {
        setTimeout(() => {
            navigator.clipboard.readText()
                .then((text) => {
                    if (text && isValidUrl(text)) {
                        setClipboard(text)
                        setTextUrl(text)
                        setTextName(getDomain(text))
                    }
                })
        }, 300)
    }, [])

    const clickHandler = async () => {

        if (!isValidUrl(textUrl)) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                591,
                '',
                '',
                `replaceTo /${l}/create-link?folderId=${folderId}`
            ))
            return
        }

        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        if (!$('#name').val() || !$('#link').val()) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                591,
                '',
                '',
                `replaceTo /${l}/create-link?folderId=${folderId}`
            ))
            return
        }
        const date = Date.now()
        const dateCreated = new Date(date)
        const timeZoneOffset = dateCreated.getTimezoneOffset()
        try {
            const data = await request(
                `${host}/api/link/create`,
                'POST',
                {
                    date: dateCreated,
                    offset: timeZoneOffset,
                    userId: auth.userId,
                    parentFID: folderId,
                    from: document.querySelector('#link').value,
                    name: document.querySelector('#name').value,
                    description: document.querySelector('#desc').value,
                    login: '',
                    password: ''
                },
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                removeCookieOfFolderId(folderId)
                window.location.replace(`/${l}/folder/open/${data.link.parentFolder}`)
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <ModalWin data={dataModal}/>
        )
    }

    return (
        <>
            <PathLineClass documents={getLocalStorageItem('documents')}/>
            <div className={"container d-flex flex-wrap justify-content-center"}>
                <div className={"col-12 col-md-9 mb-3 mt-3 d-flex"}>
                    <input
                        placeholder={lang.body.createLinkPage.placeholderName}
                        type={"text"}
                        className={"form-control"}
                        id={"name"}
                        defaultValue={textName}
                        onChange={changeHandlerName}
                    />
                    <div id={"div-paste-name"}
                         className={"btn-paste btn btn-secondary bg-white"}>
                        <i id={'btn-paste-name'} className={`fa-regular fa-paste text-success`}
                           onClick={() => {
                               document.querySelector('#name').value = getDomain(clipboard)
                           }}
                        />
                    </div>
                </div>
                <div className={"col-12 col-md-9 mb-3 d-none"}>
                    <textarea
                        placeholder={lang.body.createLinkPage.placeholderDesc}
                        className={"form-control"}
                        id={"desc"}
                        rows={"2"}
                    />
                </div>
                <div className={"col-12 col-md-9 mb-3 d-flex"}>
                    <input id={"link"}
                           placeholder={lang.body.createLinkPage.placeholderLink}
                           type={"text"}
                           className={"form-control"}
                           defaultValue={clipboard || ''}
                           onChange={changeHandlerUrl}
                    />
                    <div id={"div-paste-link"}
                         className={"btn-paste btn btn-secondary bg-white"}>
                        <i id={'btn-paste-link'} className={`fa-regular fa-paste text-success`}
                           onClick={() => {
                               document.querySelector('#link').value = getLink(clipboard)
                           }}
                        />
                    </div>
                </div>

                <button
                    className={"col-4 col-md-3 btn btn-info border-0 me-2"}
                    type={"button"}
                    onClick={() => {
                        window.location.replace(getPathBack())
                    }}>
                    {`${lang.body.general.btnBack}`}
                </button>
                <button
                    className={"col-6 col-md-4 btn btn-success border-0"}
                    type={"button"}
                    onClick={clickHandler}>
                    {lang.body.createLinkPage.btnCreateLink}
                </button>
            </div>
        </>

    )
}
